import { clientEnv } from "@/config";
import { SecureStorage } from "@/lib";
import { routes } from "@/routes";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface IGeneralStore {
  previousPath: string | null;
  setPreviousPath: (path: string | null) => void;
  phoneNumber: string;
  setPhoneNumber: (number: string) => void;
  postLoginAction: string | null;
  setPostLoginAction: (action: string | null) => void;
}

interface IGeneralSecureStore {
  persistedFields: Record<string, any>;
  setPersistedFields: (fields: Record<string, any>) => void;
}

const ENCRYPTION_KEY = clientEnv.NEXT_PUBLIC_ENCRYPTION_KEY!;
const secureStorage = new SecureStorage(ENCRYPTION_KEY, "sessionStorage");

export const useAppStore = create<IGeneralStore>()(
  persist(
    (set) => ({
      previousPath: routes.main.HOME.primaryPath,
      setPreviousPath: (path) => set({ previousPath: path }),
      phoneNumber: "",
      setPhoneNumber: (number) => set({ phoneNumber: number }),
      postLoginAction: null,
      setPostLoginAction: (action) => set({ postLoginAction: action }),
    }),
    {
      name: "novin",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        previousPath: state.previousPath,
        phoneNumber: state.phoneNumber,
        postLoginAction: state.postLoginAction,
      }),
    },
  ),
);

export const useSecureStore = create<IGeneralSecureStore>()(
  persist(
    (set) => ({
      persistedFields: {},
      setPersistedFields: (fields) => set({ persistedFields: fields }),
    }),
    {
      name: "secure-storage",
      storage: createJSONStorage(() => secureStorage),
    },
  ),
);
